// extracted by mini-css-extract-plugin
module.exports = {"button":"common-FloatingScrollButton__button--1iiZO"};